module.exports = __webpack_public_path__ + "media/backgrounds/dashboard-bg-strip-b830958f.png";